import React from 'react';
import './Header.css';

const Header = ({ onLeftMenuClick, onRightMenuClick, onSignUpClick, user }) => {
  const handleLogoClick = () => {
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="hamburger-left" onClick={onLeftMenuClick}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <div 
        className="header-logo"
        onClick={handleLogoClick}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleLogoClick();
          }
        }}
        aria-label="Refresh page - Gentrobyte AI Labs"
        title="Click to refresh"
      >
        <img 
          src="/assets/images/TopCornerLogo.png" 
          alt="Gentrobyte AI Labs"
          className="header-logo-image"
        />
      </div>

      <div className="header-right">
        {/* Temporarily commented out signup option */}
        {/* {user ? (
          <div className="user-profile">
            <img src={user.avatar} alt={user.name} className="user-avatar" />
            <span className="user-name">{user.name}</span>
          </div>
        ) : (
          <button className="signup-btn" onClick={onSignUpClick}>
            Sign Up
          </button>
        )} */}
        
        <div className="hamburger-right" onClick={onRightMenuClick}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
